var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1445,
    height: 1168,
    viewBox: "0 0 1445 1168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_1509_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0978 1107.63C44.8244 1109.78 47.9712 1110.13 50.1262 1108.4L85.2448 1080.27C87.3998 1078.54 87.7471 1075.39 86.0204 1073.24C84.2938 1071.08 81.1471 1070.73 78.9921 1072.46L47.7757 1097.47L22.7649 1066.26C21.0383 1064.1 17.8916 1063.75 15.7366 1065.48C13.5815 1067.21 13.2342 1070.35 14.9608 1072.51L43.0978 1107.63ZM56.2259 1020.91L61.1957 1021.46L56.2259 1020.91ZM497.104 642.522L496.893 647.517L497.104 642.522ZM1109.52 668.464L1109.31 673.46L1109.52 668.464ZM1071.66 11.4417L1115.71 31.7842L1119.91 22.7056L1075.86 2.36308L1071.66 11.4417ZM1203.81 72.4692L1247.86 92.8118L1252.05 83.7332L1208 63.3906L1203.81 72.4692ZM1247.86 92.8118C1259.37 98.1285 1270.39 104.089 1280.9 110.632L1286.18 102.144C1275.33 95.3826 1263.94 89.2244 1252.05 83.7332L1247.86 92.8118ZM1338.96 157.887C1356.37 176.141 1371.27 196.416 1383.43 218.138L1392.15 213.253C1379.59 190.807 1364.19 169.855 1346.2 150.987L1338.96 157.887ZM1411.59 287.531C1418.01 311.585 1421.45 336.508 1421.69 361.728L1431.69 361.632C1431.44 335.565 1427.88 309.808 1421.25 284.953L1411.59 287.531ZM1412.98 436.084C1410.01 448.097 1406.26 460.052 1401.71 471.888L1411.04 475.477C1415.74 463.252 1419.61 450.901 1422.69 438.487L1412.98 436.084ZM1401.71 471.888C1396.06 486.569 1389.35 500.606 1381.67 513.928L1390.34 518.918C1398.27 505.15 1405.21 490.644 1411.04 475.477L1401.71 471.888ZM1323.39 586.195C1300.33 607.096 1274.12 624.291 1245.76 637.132L1249.89 646.241C1279.19 632.972 1306.27 615.204 1330.11 593.605L1323.39 586.195ZM1156.27 661.828C1140.99 663.563 1125.44 664.134 1109.73 663.469L1109.31 673.46C1125.54 674.147 1141.61 673.557 1157.4 671.764L1156.27 661.828ZM1109.73 663.469L1071.45 661.847L1071.03 671.838L1109.31 673.46L1109.73 663.469ZM994.902 658.604L918.35 655.361L917.927 665.353L994.479 668.595L994.902 658.604ZM841.799 652.119L765.247 648.876L764.824 658.867L841.375 662.11L841.799 652.119ZM688.695 645.633L612.144 642.39L611.72 652.381L688.272 655.624L688.695 645.633ZM535.592 639.148L497.316 637.526L496.893 647.517L535.169 649.138L535.592 639.148ZM497.316 637.526C484.254 636.973 471.254 637.015 458.351 637.635L458.831 647.624C471.435 647.018 484.133 646.977 496.893 647.517L497.316 637.526ZM381.264 648.394C355.85 654.327 331.125 662.54 307.375 672.876L311.365 682.045C334.564 671.949 358.715 663.927 383.537 658.132L381.264 648.394ZM239.101 710.254C217.598 724.694 197.357 741.098 178.667 759.311L185.646 766.473C203.902 748.684 223.672 732.66 244.676 718.556L239.101 710.254ZM128.07 818.457C120.596 828.993 113.556 839.922 106.985 851.224L115.63 856.251C122.049 845.21 128.925 834.534 136.227 824.243L128.07 818.457ZM106.985 851.224C99.4541 864.176 92.6204 877.485 86.5026 891.094L95.6233 895.195C101.599 881.902 108.274 868.902 115.63 856.251L106.985 851.224ZM58.4864 976.123C55.316 990.704 52.8996 1005.47 51.256 1020.36L61.1957 1021.46C62.801 1006.91 65.1614 992.49 68.258 978.248L58.4864 976.123ZM51.256 1020.36L48.9495 1041.26L58.8892 1042.35L61.1957 1021.46L51.256 1020.36ZM44.3366 1083.05L42.0301 1103.95L51.9697 1105.05L54.2762 1084.15L44.3366 1083.05Z",
    fill: "url(#paint0_linear_1509_92)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_1509_92",
    x: 0.862793,
    y: 0.363083,
    width: 1443.83,
    height: 1167.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1509_92"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1509_92",
    result: "effect2_dropShadow_1509_92"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1509_92",
    result: "effect3_dropShadow_1509_92"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1509_92",
    result: "effect4_dropShadow_1509_92"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1509_92",
    result: "effect5_dropShadow_1509_92"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_1509_92",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1509_92",
    x1: 1425.78,
    y1: 50.1074,
    x2: 91.488,
    y2: 1263.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1);
export default __webpack_public_path__ + "static/media/Line 1.33b31a694c80768693ab1fcb2717e603.svg";
export { ForwardRef as ReactComponent };